import userAuthorizedAxios from './userAuthorizedAxios';
import { PhysioResults } from "../../interfaces/Blood/PhysioMarker";

export default {
  getPhysioResults: (): Promise<PhysioResults[]> => userAuthorizedAxios
    .get('/api/physio/results')
    .then((data) => data.data),
};
